<template>
  <PageLayout>
    <template #headerTitle>Client</template>

    <VBusHelper
      :emitOnMounted="$constants.EVENTS.CUSTOMERS.DETAIL.REFRESH"
      :dataOnMounted="{ id: $route.query.id }"
    />

    <div
      v-if="!$stores.customers?.state?.detail?.loading && $stores.customers?.state?.detail?.data"
      class="space-y-6"
    >
      <!-- HEADER WITH BACK BUTTON -->
      <div class="flex items-center gap-4">
        <button
          class="w-10 h-10 flex items-center justify-center rounded-full bg-slate-200 hover:bg-slate-300 transition-colors"
          @click="$router.push('/customers')"
        >
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
          </svg>
        </button>
        <h1 class="text-xl font-semibold">Détail du client</h1>
      </div>

      <!-- CUSTOMER INFO CARD -->
      <CustomerItem
        :item="$stores.customers?.state?.detail?.data"
        :detailMode="true"
      />

      <!-- WALLET BALANCE CARD -->
      <div class="bg-white rounded-2xl p-6 shadow-sm">
        <h2 class="text-lg font-semibold text-gray-900 mb-4">Solde du client</h2>
        <div class="flex items-center gap-3">
          <div
            class="w-12 h-12 rounded-xl bg-gradient-to-br from-green-500 to-green-600 flex items-center justify-center"
          >
            <svg class="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>
          <div class="flex-1">
            <WalletBalance
              v-if="$stores.customers?.state?.detail?.data?.id"
              :userId="$stores.customers?.state?.detail?.data?.id || 'none'"
            />
          </div>
          <div class="text-right">
            <div class="text-sm text-gray-500">Devise</div>
            <div class="font-semibold text-gray-900">XOF</div>
          </div>
        </div>
      </div>

      <!-- TRANSACTIONS CARD -->
      <div class="bg-white rounded-2xl shadow-sm overflow-hidden">
        <div class="p-6 border-b border-gray-100">
          <h2 class="text-lg font-semibold text-gray-900">Transactions</h2>
        </div>
        <div v-if="$stores.customers?.state?.detail?.data?.id">
          <TransactionList
            :userId="$stores.customers?.state?.detail?.data?.id || 'none'"
          />
        </div>
      </div>
    </div>

    <!-- LOADING STATE -->
    <div
      v-else-if="$stores.customers?.state?.detail?.loading"
      class="space-y-6"
    >
      <div class="bg-white rounded-2xl p-6 h-48 shimmer"></div>
      <div class="bg-white rounded-2xl p-6 h-32 shimmer"></div>
      <div class="bg-white rounded-2xl p-6 h-64 shimmer"></div>
    </div>
  </PageLayout>
</template>

<script setup>
import { onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
const router = useRouter();
const route = useRoute();

onMounted(() => {
  if (!route.query.id) router.push('/customers');
});
</script>
